import { render } from "./ItemDropdown.vue?vue&type=template&id=8035a40a"
import script from "./ItemDropdown.vue?vue&type=script&lang=js"
export * from "./ItemDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__